/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import moment from 'moment';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';

import TableComponent from '../../components/TableComponent';
import { errorToast, successToast } from '../../helpers';
import { ConfirmationModal } from '../../Modals/confirmationModal';
import EditUser from '../../Modals/editUser';
import UserRating from '../../Modals/userRating';
import {
  useChangeSubadminStatusMutation,
  useLazyAllsubAdminQuery,
  useLazyDeleteSubadminQuery,
  useUpdateSubadminMutation,
} from '../../service/user&Roles';
// import { useLazyAllsubAdminQuery } from "../../service/subAdmin";
import { CommonBody } from '../../types/General';
import { generateEncryptedKeyBody } from '../../utils/crypto';
import { UPDATE_TYPES } from '../../utils/enums';

interface UserListTableProps {
  flag: boolean;
  selectedId: string;
  setSelectedId: React.Dispatch<React.SetStateAction<string>>;
  page: number;
  debouncedSearchTerm: string;
  setDebouncedSearchTerm: React.Dispatch<React.SetStateAction<string>>;
  handleProfileUpload: any;
  selectedImage: any;
  setSelectedImage: any;
  roles: any;
  handleSubmit: any;
  name: string;
  setName: Dispatch<SetStateAction<string>>;
  email: any;
  setEmail: any;
  phone: any;
  dialCode: any;
  setDialCode: Dispatch<SetStateAction<any>>;
  handleChangePhone: any;
  profileImage?: any;
  setPhone: Dispatch<SetStateAction<string>>;
  setProfileImage?: Dispatch<SetStateAction<string>>;
  setRoles?: React.Dispatch<React.SetStateAction<any[]>>;
  selectedRole: any[];
  setSelectedRole: React.Dispatch<React.SetStateAction<any[]>>;
  count: number;
}

const UserListTable: React.FC<UserListTableProps> = ({
  flag,
  selectedId,
  setSelectedId,
  handleProfileUpload,
  selectedImage,
  setSelectedImage,
  roles,
  name,
  setName,
  email,
  setEmail,
  phone,
  setPhone,
  dialCode,
  setDialCode,
  handleChangePhone,
  profileImage,
  setSelectedRole,
  selectedRole,
}) => {
  const [updateSubadmin] = useUpdateSubadminMutation();
  const handleSubmit = async () => {
    if (!email?.length) {
      return;
    }
    if (phone?.length <= 5) {
      return;
    }
    if (!selectedRole) {
      errorToast('Please select a role');
      return;
    }
    const body = {
      name: name,
      phoneNo: phone,
      dialCode: dialCode,
      email: email,
      accessRoleId: selectedRole,
      image: profileImage,
    };
    try {
      setLoading(true);
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await updateSubadmin({
        body: encryptedBody,
        id: selectedId,
      }).unwrap();

      if (response?.statusCode === 200) {
        successToast('Subadmin details updated successfully');

        setOpenModal(false);
        fetchSubadmins();
      }
    } catch (error: any) {
      setLoading(false);
      errorToast(error?.data?.message || '');
      console.error(error);
    }
  };
  // const [selectedRole, setSelectedRole] = useState("");
  const [openDelete, setOpenDelete] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [deleteSubadmin] = useLazyDeleteSubadminQuery();
  const [loading, setLoading] = useState(false);
  const [getSubAdmin] = useLazyAllsubAdminQuery();
  const label = { inputProps: { 'aria-label': 'Switch demo' } };
  const [rows, setRows] = useState<any>([]);
  //status Change

  const [changeStatus] = useChangeSubadminStatusMutation();
  const handleUserUpdate = async (id: string, status: boolean, type: string) => {
    const body = {
      ...(type === UPDATE_TYPES.BLOCK ? { isBlocked: status } : {}),
    };

    try {
      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;

      const response = await changeStatus({
        body: encryptedBody,
        id: id,
      }).unwrap();
      if (response?.statusCode === 200) {
        fetchSubadmins();
        if (status === true) {
          successToast('User blocked successfully');
        } else {
          successToast('User unblocked successfully');
        }
      } else {
        errorToast('Please try again');
      }
    } catch (error: any) {
      console.error(error, 'Error');
      errorToast(error?.data?.message || 'An error occurred');
    }
  };
  const [count, setCount] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => {
    setOpenModal(false);
  };

  // fatch subAdmin
  const fetchSubadmins = async () => {
    setLoading(true);
    try {
      const response = await getSubAdmin({
        page: page,
        limit: 10,
        // search: debouncedSearchTerm,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setRows(response?.data?.user);
        setCount(response?.data?.count);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast('error?.data?.message');
      setLoading(false);
    }
  };

  //delete Subadmin
  const handleDelete = async () => {
    setLoading(true);
    try {
      const response = await deleteSubadmin({ id: selectedId }).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        successToast('SubAdmin deleted successfully');
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || '');
    } finally {
      setLoading(false);
      fetchSubadmins();
    }
  };

  useEffect(() => {
    fetchSubadmins();
  }, []);

  // const rows = [
  //   {
  //     id: 1,
  //     role: "Administrator",
  //     mobile: "(555) 123-4567",
  //     lastLogin: "20 mins ago",
  //   },
  //   {
  //     id: 2,
  //     role: "Administrator",
  //     mobile: "(555) 123-4567",
  //     lastLogin: "20 mins ago",
  //   },
  //   {
  //     id: 3,
  //     role: "Administrator",
  //     mobile: "(555) 123-4567",
  //     lastLogin: "20 mins ago",
  //   },
  //   {
  //     id: 4,
  //     role: "Administrator",
  //     mobile: "(555) 123-4567",
  //     lastLogin: "20 mins ago",
  //   },
  //   {
  //     id: 5,
  //     role: "Administrator",
  //     mobile: "(555) 123-4567",
  //     lastLogin: "20 mins ago",
  //   },
  // ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 230,
      field: 'user',
      headerName: 'Subadmin',
      editable: false,
      renderCell: ({ row }) => {
        const imageSrc = row?.image || 'static/images/user.png';
        return (
          <div className="user_block">
            <figure>
              <img
                src={imageSrc}
                alt="User"
                style={{ width: '40px', height: '40px', borderRadius: '50%' }}
              />
            </figure>
            <p className="cursor_p" onClick={() => setOpenModal(true)}>
              <b>{row?.name}</b>
              {row?.email}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: 'role',
      headerName: 'Role',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return <b>{row?.accessRole?.name}</b>;
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: 'phoneNo',
      headerName: 'Mobile',
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 100,
      field: 'createdAt',
      headerName: 'Created Date',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <b>{moment(row?.createdAt).format('YYYY-MM-DD') || '-'}</b>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: 'twoStep',
      headerName: 'Unblock/Block',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            size="small"
            checked={row?.isBlocked}
            onChange={() => handleUserUpdate(row?._id, !row?.isBlocked, UPDATE_TYPES.BLOCK)}
          />
        );
      },
    },
    {
      flex: 1,
      minWidth: 140,
      field: 'action',
      headerName: 'action',
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() => {
                  flag = false;
                  setName(row?.name);
                  setSelectedRole(row?.accessRole?._id);
                  setPhone(row?.phoneNo);
                  setDialCode(row?.dialCode);
                  setEmail(row?.email);
                  setSelectedImage(row?.image);
                  setSelectedId(row?._id);
                  setOpenEdit(true);
                }}
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>

            <Box>
              <IconButton
                onClick={() => {
                  flag = false;
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];

  const hidden = ['fullName'];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          loading={loading}
          count={count}
          page={page}
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
      <ConfirmationModal
        text={'Are you sure to delete this sub-admin?'}
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={handleDelete}
      />
      <EditUser
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        setOpen={setOpenEdit}
        selectedId={selectedId}
        fetchSubadmins={fetchSubadmins}
        handleUserUpdate={handleUserUpdate}
        flag={flag}
        setFlag={setOpenDelete}
        handleProfileUpload={handleProfileUpload}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        roles={roles}
        handleSubmit={handleSubmit}
        name={name}
        setName={setName}
        email={email}
        setEmail={setEmail}
        phone={phone}
        setPhone={setPhone}
        handleChangePhone={handleChangePhone}
        dialCode={dialCode}
        setDialCode={setDialCode}
        setSelectedRole={setSelectedRole}
        selectedRole={selectedRole}
        openEdit={openEdit}
        setOpenEdit={setOpenEdit}
      />
      <UserRating open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
    </>
  );
};

export default UserListTable;
